export default {
  "meeting": {
    applyrecurring: 'Die Änderungen werden auf den neuen wiederkehrenden Zeitplan angewendet. Vergangene Meetings bleiben unverändert.',
    recurrenceDescribeTwo: 'Findet alle {loopPulse} Wochen am {week} statt, vom {start} bis {end}',
    wanttodeletethemeetingfollowTwo: 'Ausgewähltes Meeting und alle nachfolgenden wiederkehrenden Meetings löschen?',

    loopCycleSelectTips: 'Bitte wählen Sie den Wochentag für die Wiederholung aus.',

    export: 'Exportieren',
    exportMeetingFileFuncTipsTitle: 'Exportbestätigung',
    exportMeetingFileFuncTipsContentOne: 'Es wurden keine Filter angewendet. Das System exportiert standardmäßig die Besprechungsdaten des aktuellen Jahres.',
    exportMeetingFileFuncTipsContentTwo: 'Um Besprechungen aus einem anderen Zeitraum zu exportieren, wenden Sie bitte vor dem Export die gewünschten Filter an.',

    myMeetingSearch: 'Meine Meetings',
    meetingTimeSearch: 'Besprechungszeit',
    meetingRoomsSearch: 'Besprechungsraum',

    Recurring: 'Wiederkehrend:',
    wanttodeletethemeetingfollow: 'Möchten Sie dieses Meeting und alle folgenden Meetings wirklich löschen?',
    endTimeCannotBeforeBeginTime: 'Das Enddatum darf nicht vor dem Startdatum liegen',
    Thismeeting: 'Dieses Meeting',
    Recurringmeeting: 'Wiederkehrendes Meeting',
    Checkin: 'Check-in:',
    checkinTip: 'Nach der Aktivierung können Teilnehmer durch Scannen des QR-Codes des Raumplaners einchecken.',
    Recurrence_Setrecurrence: 'Wiederholung festlegen',
    Recurrence_Start: 'Start',
    Recurrence_RepeatEvery: 'Wiederholen alle',
    Recurrence_Week: 'Woche',
    Recurrence_end: 'Ende',
    recurrenceDescribe: 'Findet alle {week} statt, beginnend am {start} bis {end}',
    Recurrence_DoesnotRepeat: 'Nicht wiederholen',
    Recurrence_Weekly: 'Wöchentlich',

    AddressBookUser: 'Benutzer',
    AddressBookPhonebook: 'Adressbuch',

    RoomByPeopleNum1: '2 Personen oder weniger',
    RoomByPeopleNum2: '3-6 Personen',
    RoomByPeopleNum3: '7-10 Personen',
    RoomByPeopleNum4: '11-15 Personen',
    RoomByPeopleNum5: '16-20 Personen',
    RoomByPeopleNum6: '21-30 Personen',
    RoomByPeopleNum7: 'Mehr als 30 Personen',

    whoAreBound: 'Benutzer, die mit einem Systemkonto verbunden sind, sehen das Meeting im Systemkalender. Benutzer mit angegebener E-Mail-Adresse erhalten Benachrichtigungen per E-Mail. Um E-Mails zu erhalten, vervollständigen Sie Ihre Angaben unter [Mein Profil].',

    AttendessMeeting: 'Teilnehmer:',
    SelectAttendessMeetingTip: 'Teilnehmer auswählen',

    MeetingFilter: 'Meeting-Filter',
    HostedbyMe: 'Von mir organisiert',
    Invitedby: 'Von mir eingeladen',
    Otherby: 'Andere',

    "AddressIsDuplicated": "Die Kontakt-E-Mail ist doppelt vorhanden",
    "meetingExpired": "Abgelaufen",
    titlePhoneFormat: 'Das Telefon darf nur Zahlen, () + und - enthalten.',
    "selectField": "Bitte wählen Sie eine Datei aus",
    "Limit255": "Der Dateiname darf 255 Zeichen nicht überschreiten",
    "nameLimit25": "Der Name darf 25 Zeichen nicht überschreiten",
    "emailLimit50": "Die E-Mail darf 50 Zeichen nicht überschreiten",
    "emailFormatError": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "phoneLimit11": "Die Telefonnummer kann bis zu 11 Ziffern enthalten",
    "ParticipantsEmail": "E-Mail des Teilnehmers:",
    "listIsEmpty": "Die Liste ist leer",
    "Startimporting": "Upload starten",
    "Selectfile": "Datei auswählen",
    "Importfile": "Datei importieren",
    "ImportfileTip": "*Es werden nur CSV-Dateien im Outlook-Format (.csv) oder vCard-Dateien (.vcf) zum Import unterstützt.",
    "addParticipants": "Teilnehmer hinzufügen",
    "multiselectdeselect": "Hinweis zum Löschen von Tags",
    "multiselectselected": "Auswahlhinweis",
    "enterOrSelectALabel": "E-Mail des Teilnehmers auswählen",
    "deleTitleContact": "Möchten Sie diesen Kontakt wirklich löschen?",
    "delTitleContactContent": "Kontakt löschen?",
    "deleteContactTitle": "Bitte wählen Sie den zu löschenden Kontakt aus",
    "editcontact": "Kontakt bearbeiten",
    "Name": "Name",
    "email": "E-Mail",
    "telephoneNumber": "Telefon",
    "Addcontact": "Kontakt hinzufügen",
    "Importcontactfile": "Kontakte importieren",
    "AddressBook": "Adressbuch",
    "Participants": "Teilnehmer:",

    bindTipContent:"Diese Organisation hat bereits einen Drittanbieter-Kalender gebunden. Bitte planen Sie Meetings über Outlook/Teams.",
    Productupdatenews: 'Ein neues Versionsupdate wurde veröffentlicht. ',
    bookingPerson: 'Gebucht von',
    "DeleteMeeting": "Meeting löschen",
    "wanttodeletethemeeting": "Möchten Sie das Meeting löschen?",
    "hasbeendeleted": "Das Meeting wurde gelöscht",
    "theMeetingWasAborted": "Meeting vorzeitig beenden",
    "theMeetingWasAbortedContent": "Möchten Sie das Meeting vorzeitig beenden?",
    "determineTheAbortTask": "Meeting vorzeitig beenden",
    "theMeetingEndedEarly": "Das Meeting wurde vorzeitig beendet.",
    "with": "mit",
    "Other": "Anderes",
    "tasks": "Konflikt von Aufgaben",
    "conflict": "Die folgende Besprechungszeit kollidiert:",
    "meetConflicts": "Vergangene Zeiten können nicht ausgewählt werden",
    "itIsNotAllowedToSelectThePastTime": "Ausgewählt",
    "selected": "Wählen Sie nicht mehr als 5 Besprechungsräume",
    "noOverFive": "Genehmigungsmeinungen",
    "approvalOpinions": "Über die Zeitgrenze hinaus kann nicht ausgewählt werden",
    "beyondTheTimeLimitItCannotBeSelected": "Startmonat",
    "startMonth": "bis",
    "to": "Endmonat",
    "stopMonth": "Kein Start",
    "didnTStart": "Läuft",
    "ONGOING": "Beendet",
    "ENDED": "wurde",
    "hasBeen": "Reservierung",
    "booking": "Genehmigung",
    "Approval": "Besprechungsraum",
    "MeetingRoom": "Alle Räume",
    "AllRoom": "Verfügbar",
    "Available": "Besprechung einleiten",
    "Initiate": "Besprechung genehmigen",
    "MeetingApproval": "Vormonat",
    "PreviousMonth": "Heute",
    "Today": "Nächster Monat",
    "NextMonth": "Jahr/Monat",
    "YearMonth": "Zeitanzeige",
    "TimeDisplay": "Abkürzung des Besprechungstitels",
    "MeetingTitleAbbreviation": "Besprechung einleiten",
    "InitiateMeeting": "Kommende Besprechungen",
    "PendingMeetings": "Alle Besprechungen",
    "AllMeetings": "Es gibt keine Besprechungen zum Teilnehmen im Moment",
    "noMeetings": "Nicht begonnen",
    "NotStarted": "Organisator",
    "Organizer": "Datum und Uhrzeit",
    "MeetingDateTime": "Standort",
    "MeetingLocation": "Besprechungsthema",
    "MeetingSubject": "Eingeladene Personen",
    "Invited": "Zugelassene Personen",
    "PeopleAccepted": "Besprechung bearbeiten",
    "EditMeeting": "Besprechung absagen",
    "CancelMeeting": "Besprechung einleiten/bearbeiten",
    "InitiateEditMeeting": "Thema",
    "Subject": "Thema",
    "Presenter": "Präsentator :",
    "DateTime": "Datum & Uhrzeit",
    "TimeAndZone": "Zeitzone",
    "Attendees": "Teilnehmer",
    "Addrequiredattendees": "Erforderliche Teilnehmer hinzufügen",
    "SelectRooms": "Räume auswählen",
    "Reminder": "Erinnerung",
    "Remindbeforestart": "Vor dem Beginn erinnern",
    "Confirm": "Bestätigen",
    "topic": "Thema :",
    "topicplace": "Neuer Besprechungstitel :",
    "speaker": "Präsentator :",
    "speakerplace": "Bitte geben Sie die Informationen des Präsentators ein",
    "DateAndTime": "Datum & Uhrzeit :",
    "TimeZone": "Zeitzone",
    "EndDate": "Enddatum",
    "Rooms": "Räume :",
    "Notes": "Notizen :",
    "MeetingRoomApproval": "Genehmigung des Besprechungsraums",
    "PendingApproval": "Wartet auf Genehmigung",
    "Approved": "Genehmigt",
    "nopendingapprovals": "Es gibt keine ausstehenden Genehmigungen",
    "Applicant": "Antragsteller",
    "UsageTime": "Nutzungszeit",
    "ApprovalResult": "Genehmigungsergebnis",
    "ApprovalComments": "Genehmigungsbemerkungen",
    "Approve": "Genehmigen",
    "Reject": "Ablehnen",
    "Search": "Suchen",
    "Filter": "Filtern",
    "scanTheQRCodeToSignIn": "Scannen Sie den QR-Code, um sich anzumelden"
  },
  "NPS": {
    "Relay": "Relay",
    "RelaySettings": "Relay-Einstellungen",
    "DevicePower": "Gerätesteuerung",
    "DeviceElevation": "Höhenkontrolle",
    "LinageWithNPSPower": "Verknüpfung mit NPS-Strom",
    "PresentationSwitch": "Präsentationsschalter",
    "Duplicate": "Duplizieren",
    "LinkagewithNPSPowe": "Verknüpfung mit NPS-Strom",
    "npsTooltip": "USB-Geräte können nur von einem PC-Host aufgerufen werden, der auf HDMI OUT 1 geschaltet ist.",
    "nmpTooltip": "Klicken Sie auf die Schaltfläche 'Duplizieren', um den Bildschirminhalt auf anderen Displays zu spiegeln und die Anzeige auf mehreren Bildschirmen zu synchronisieren."
  },
  "textTemplate": {
    "template2513": "Feuer Notfallübertragung",
    "template2514": "Bitte evakuieren Sie über den Notausgang und den Feuerfluchtweg zu einem sicheren Ort gemäß dem Feuerfluchtplan.",
    "moreTemplate": "Vorlagenlimit erreicht",
    "add": "Hinzufügen",
    "SetTemplate": "Vorlage festlegen",
    "Emergency": "Notfall",
    "General": "Allgemein",
    "BroadcastDevices": "Übertragungsgerät:",
    "selectBroadcastDevices": "Bitte wählen Sie Übertragungsgeräte aus",
    "All": "Alle",
    "AddTemplate": "Vorlage hinzufügen",
    "EditTemplate": "Vorlage bearbeiten",
    "deleteTemplage": "Möchten Sie die ausgewählte Vorlage wirklich löschen?",
    "title": "Vorlage löschen",
    "selectTemplage": "Bitte wählen Sie eine Vorlage!",
    "DeleteCancelled": "Löschen abgebrochen!",
    "DeletedSuccessfully": "Erfolgreich gelöscht!",
    "noData": "Es kann keine Vorlage verwendet werden, klicken Sie auf die obere rechte Ecke, um eine Vorlage hinzuzufügen.",
    "TemplateTitle": "Vorlagetitel:",
    "BroadcastType": "Übertragungsart:",
    "BroadcastTypeDialog": "Übertragungsart:",
    "selectBroadcastType": "Bitte wählen Sie die Übertragungsart aus",
    "BroadcastDuration": "Übertragungsdauer:",
    "BroadcastDevice": "Übertragungsgerät:",
    "BroadcastContent": "Übertragungsinhalt:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "Fehler!",
    "mediaTimeStateNotifyErrorContent": "Ihr Streaming-Service ist abgelaufen, bitte wenden Sie sich rechtzeitig an Ihren Agenten, um ihn zu erneuern.",
    "mediaTimeStateNotifyWarnTitle": "Achtung!",
    "mediaTimeStateNotifyWarnContent": "Sie befinden sich derzeit im Testmodus und können nur auf maximal 3 Endgeräte streamen und senden.",
    "mediaTimeStateNotifySuccessTitle": "Erfolgreiche Erneuerung",
    "mediaTimeStateNotifySuccessContent": "Ihr Streaming-Service ist bereit für die normale Nutzung. Vielen Dank.",
    "company": "Firmenname:",
    "tableAddress": "Adresse:",
    "createTime": "Erstellungsdatum:",
    "email": "E-Mail:",
    "phone": "Telefon:",
    "Trial": "Test",
    "TrialWorkstation": "Sie befinden sich derzeit im Testmodus und können nur auf maximal 3 Endgeräte streamen und senden.",
    "Normal": "Normal",
    "NormalWorkstation": "Die Gültigkeitsdauer Ihres Streaming-Services reicht von",
    "to": "bis",
    "Advent": "Bald",
    "AdventWorkstationOne": "Ihr Streaming-Service läuft am",
    "AdventWorkstationTwo": "ab, bitte wenden Sie sich rechtzeitig an Ihren Agenten, um ihn für die normale Nutzung zu erneuern.",
    "Expired": "Abgelaufen",
    "ExpiredWorkstation": "Ihr Streaming-Service ist abgelaufen, bitte wenden Sie sich rechtzeitig an Ihren Agenten, um ihn zu erneuern."
  },
  "route": {
    "dashboard": "Dashboard",
    "i18n": "I18n",
    "Devices": "Geräte",
    "Broadcast": "Übertragung",
    "Schedule": "Zeitplan",
    "Resources": "Ressourcen",
    "Live": "Streaming",
    "meetings": "Meeting"
  },
  "navbar": {
    "updates":"Neueste Updates",
    "logOut": "Abmelden",
    "screenfull": "Vollbild",
    "oprofile": "Mein Profil",
    "settings": "Einstellungen",
    "language": "Sprache",
    "BackTianwa": "Zurück zu Tianwa",
    "newUserGuide": "Benutzerhandbuch"
  },
  "feedback": {
    "Feedback": "Feedback",
    "email": "Bitte hinterlassen Sie Ihre E-Mail für unser Feedback.",
    "content": "Willkommen und hinterlassen Sie Nachrichten zur Verbesserung unserer Produkte. Vielen Dank für Ihre Kommentare.",
    "submit": "Absenden",
    "emailNoEmpty": "E-Mail darf nicht leer sein",
    "emailTrueRule": "Bitte geben Sie das richtige E-Mail-Format ein",
    "contentNoEmpty": "Der Inhalt darf nicht leer sein",
    "feedbackSuccess": "Feedback erfolgreich",
    "feedbackFailed": "Feedback fehlgeschlagen",
    "emailNoChinese": "Die E-Mail darf keine chinesischen Zeichen enthalten",
    "emailLength": "Zwischen 5 und 50 Zeichen lang",
    "emailSpecialString": "Die E-Mail darf keine Sonderzeichen enthalten"
  },
  "login": {
    checkPasswordTitleTwo: 'Bitte legen Sie ein Passwort mit mindestens 6 Zeichen fest, das Buchstaben und Zahlen enthält. Sonderzeichen sind erlaubt (keine Einschränkungen).',
    captcha: 'Verifizierungscode',
    checkPasswordTitle: 'Das Passwort muss mindestens 6 Zeichen lang sein und darf nicht nur aus Zahlen bestehen',
    "title": "WILLKOMMEN",
    "logIn": "Einloggen",
    "consoleLogin": "Konsole Einloggen",
    "username": "Benutzername",
    "password": "Passwort",
    "any": "beliebig",
    "thirdparty": "Oder verbinden Sie sich mit",
    "thirdpartyTips": "Kann lokal nicht simuliert werden, bitte kombinieren Sie es mit Ihrer eigenen Geschäftssimulation!",
    "placeholder": ["Benutzername","Passwort","Verifizierungscode"],
    "userNameTitle": "Falscher Benutzername!",
    "forget": "Haben Sie es vergessen?",
    "loginTitle0": "Erfolgreich eingeloggt!",
    "loginTitle1000": "Falscher Benutzername oder Passwort!",
    "loginTitle1001": "Benutzername und Passwort müssen ausgefüllt werden!",
    "loginTitle1002": "Verifizierungscode muss ausgefüllt werden!",
    "loginTitle1003": "Benutzerstatus ist illegal, Login fehlgeschlagen!",
    "loginTitle1004": "Fehler im Verifizierungscode!",
    "loginTitle1005": "Nicht eingeloggt, bitte zuerst einloggen!",
    "loginTitle1006": "Die beiden Passwörter sind unterschiedlich!",
    "loginTitleUserName": "Benutzername muss ausgefüllt werden!",
    "loginTitlePwd": "Passwort muss ausgefüllt werden!",
    "loginTitleVercode": "Verifizierungscode muss ausgefüllt werden!",
    "titleLoginNameFormat": "Das Konto muss aus Zeichen oder Zeichen und Zahlen bestehen.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "Geräte",
    "btnRoadcast": "Übertragung",
    "btnResources": "Ressourcen",
    "btnLive": "Streaming",
    "meetings": "Meeting",
    "todaySchedule": "Heutiger Zeitplan",
    "allSkedules": "Alle Zeitpläne",
    "details": "Details",
    "btnStart": "Starten",
    "titleContent": "Hallo! Die Q-NEX-Konsole steht Ihnen zur Verfügung. Lassen Sie uns beginnen!",
    "btnExit": "Beenden"
  },
  "devices": {
    ptzCamera:'PTZ-Kamera',
    "start": "STARTEN",
    "stop": "STOPPEN",
    "nmpPowerOff_mandatory": "Im Broadcast (nicht obligatorisch)",
    "nmpPowerOff_nomandatory": "Im Broadcast (nicht obligatorisch). Weiter ausführen?",
    "nmpsPowerOff_mandatory": "Einige NMPs sind im Broadcast (obligatorisch).",
    "nmpsPowerOff_nomandatory": "Einige NMPs sind im Broadcast (nicht obligatorisch). Weiter ausführen?",
    "reset": "Zurücksetzen",
    "displayedInTheControlArea": "Im Steuerzentrum angezeigt",
    "dragOrder": "Reihenfolge ziehen",
    "areaSettingTwoNotice": "*RS232-, AC- und Fernbedienungssteuerung werden im Steuerzentrum je nach NMP-Bindungsstatus im Dashboard angezeigt.",
    "areaSettingThreeNotice": "*CBX-Steuerung wird im Steuerzentrum je nach NMP-Bindungsstatus im Dashboard angezeigt.",
    "controlSet": "Steuerzentrum-Einstellungen",
    "vcbNoLine": "Kein CBX-Gerät ist online",
    "vcbNoBound": "Kein CBX-Gerät ist gebunden",
    "tscNoBound": "RS232 auf TSC ist nicht mit Daten gebunden. Bitte informieren Sie den Administrator, es im Dashboard zu verbinden.",
    "light": "Leistungssteuerung",
    "vcbpower": "Leistung",
    "rs232Control": "Serielle Steuerung",

    "CBX": {
    "powerSupplyON": "Einschalten",
    "powerSupplyOFF": "Ausschalten",
    "lockScreenON": "Sperren",
    "lockScreenOFF": "Entsperren",
    "childLockON": "Kindersicherung aktiviert",
    "childLockOFF": "Kindersicherung deaktiviert",
    "energySavingON": "Energiesparmodus aktiviert",
    "energySavingOFF": "Energiesparmodus deaktiviert",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "Android",
    "volumeAdjustment": "Lautsprecher",
    "brightAdjustment": "Helligkeit",
    "other": "Weitere Funktionen..."
    	},

    "InterfaceOne": "Schnittstelle Eins",
    "InterfaceTwo": "Schnittstelle Zwei",
    "abcStyleP": "Entschuldigung! TSC und (NMP, MBX, NPS, NDP100, NDP500) können nicht gleichzeitig ausgewählt werden",
    "masterControl": "haupt",
    "powerSupply": "Strom",
    "RecordingControl": "Aufnahme Steuerung",
    "RecordingControlSystem": "Vorlesungsaufnahmesystem",
    "LiquidCrystal": "Interaktives LCD-Display",
    "projector": "Projektor",
    "othertype": "Andere",
    "lockScreen": "Sperre",
    "childLock": "Kindersicherung",
    "energySaving": "Energiesparmodus",
    "signalSourceSwitching": "Eingangsquelle",
    "volumeAdjustment": "Lautsprecher",
    "brightAdjustment": "Helligkeit",
    "other": "Weitere Funktionen",
    "otherFunction": "Funktion",
    "send": "Senden",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "Klimaanlage",
    "titleDevices": "Gruppenfilter:",
    "content": "Suchen",
    "selectALL": "Alles auswählen",
    "SelectRecentPage": "Aktuelle Seite auswählen",
    "controlPanel": "Kontrollzentrum",
    "displayInputSwitch": "Anzeige-Eingangsschalter",
    "chooseINPUTSources": "Eingangsquellen auswählen",
    "speakerVolume": "Audio Lautstärke",
    "bass": "Bass",
    "treble": "Höhen",
    "MICVolume": "Mikrofonlautstärke",
    "AirConditioning": "Klimaanlage",
    "model": "Modell",
    "setTemp": "Eingestellte Temperatur",
    "fanSpeed": "Lüftergeschwindigkeit",
    "bold": "Schwingen",
    "projectionScreen": "Projizierbildschirm",
    "electronicLock": "Elektrisches Schloss",
    "electronicLock1": "Elektrisches Schloss",
    "selectDevices": "Bitte wählen Sie ein Gerät oder eine Gruppe von Geräten aus",
    "isCompelType": "Die Gerätesteuerung ist aufgrund einer obligatorischen Übertragung nicht verfügbar, bitte versuchen Sie es später erneut.",
    "mainPower": "Hauptstrom",
    "extraPower": "Zusatzstrom",
    "power": "Strom",
    "hdmiBroadcast": "Übertragung",
    "equipmentState1": "Ein",
    "equipmentState2": "Aus",
    "equipmentState3": "Offline",
    "main": "Haupt",
    "external": "Extern",
    "ProjectionScreen": "Projizierbildschirm",
    "UP": "HOCH",
    "DOWN": "RUNTER",
    "LOCK": "VERRIEGELN",
    "UNLOCK": "ENTRIEGELN",
    "PleaseDevice": "Bitte wählen Sie das oder die Geräte links aus",
    "RemoteControl": "Fernbedienung",
    "Action": "Aktion",
    "Devicefilter": "Gerätefilter",
    "DeviceStatus": "Status",
    "DeviceType": "Typ",
    "currentAudioSource": "Aktuelle Audioquelle",
    "audioSwitching": "Audioausgangsschalter"
  },
  "broadcast": {
    "isBoarding": "(In der Übertragung)",
    "last3Days": "LETZTE 3 TAGE",
    "last7Days": "LETZTE 7 TAGE",
    "last30Days": "LETZTE 30 TAGE",
    "historyRecord": "Historie",
    "SelectDestination": "1.Ziel auswählen",
    "BroadcastingConsole": "2.Sende-Konsole",
    "Notification": "Benachrichtigung",
    "btnStop": "Stoppen",
    "btnStart": "Starten",
    "Letters60": "(weniger als 60 Zeichen)",
    "Letters300": "(weniger als 300 Zeichen)",
    "LastingTime": "Dauer:",
    "Title": "Titel:",
    "Content": "Inhalt:",
    "Cannotquit": "Obligatorische Übertragung",
    "ChooseMedia": "Medien-Datei auswählen",
    "Broadcasting": "Übertragung",
    "dialogTitle": "Video- und Audio-Ressourcen",
    "SortBy": "Sortieren nach",
    "btnBake": "Zurück zur vorherigen",
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "save": "Speichern",
    "coxAll": "Alles",
    "PublicCloud": "Öffentlicher Speicher",
    "IndividualCloud": "Persönlicher Speicher",
    "selFile": "Bitte wählen Sie eine Datei oder eine Gruppe.",
    "StopBroadcast": "Übertragung stoppen",
    "StartBroadcasting": "Übertragung starten",
    "StopBroadcasting": "Übertragung stoppen",
    "ForceQuit": "Erzwingen Sie den Abbruch",
    "PleaseMediaFile": "Bitte wählen Sie eine Mediendatei",
    "PleaseDevice": "Bitte wählen Sie ein Gerät",
    "broadcast_0": "Übertragung starten",
    "broadcast_2500": "Die maximale Anzahl von verbundenen Geräten für den Medienserver wurde überschritten",
    "broadcast_2501": "Fehler bei der Übertragungsdatei",
    "broadcast_2502": "Übertragung beendet",
    "broadcast_2503": "Konnte keine Informationen vom Medienserver erhalten",
    "broadcast_2510": "Achtung! Sie befinden sich derzeit im Testmodus. Bis zu 3 Endgeräte können Empfangsbefehle für die Übertragung erhalten. Bitte überprüfen Sie die Anzahl der ausgewählten Geräte.",
    "broadcast_2018": "Der Streaming-Dienst ist ausgeschaltet.",
    "broadcast_2019": "Der Streaming-Dienst ist abgelaufen.",
    "broadcast_2512": "Die Höchstgrenze für die Anzahl der Vorlagen wurde überschritten.",
    "broadcast_2513": "Brandnotfall-Übertragung.",
    "broadcast_2514": "Bitte evakuieren Sie sich über den Notausgang und den Feuerfluchtweg an einen sicheren Ort gemäß dem Brandschutzplan.",
    "broadcast_2006": "Gerät nicht gefunden.",
    "broadcast_2": "Der Festplatten-Dienst ist anormal.",
    "broadcast_2515": "Wählen Sie ein Gerät ohne Übertragungsfunktionen.",
    "broadcast_2516": "Wählen Sie Dateien aus, die die maximale unterstützte Auflösung von NMP überschreiten.",
    "broadcast_2517": "Wählen Sie Dateien aus, die die maximale unterstützte Auflösung von NDP500 überschreiten.",
    "broadcast_Title": "Übertragungswarnung.",
    "broadcast_TitleNDP500": "Übertragungswarnung NDP500.",
    "broadcast_content": "Das Gerät unterstützt bis zu 4K@30FPS, mit einer optimalen Auflösung von 1080P@30FPS.",
    "broadcast_contentNDP500": "NDP500/600 unterstützt bis zu 1080P@30FPS, mit einer optimalen Auflösung von 720P@30FPS.",
    "broadcast_noSupported": "Die folgenden ausgewählten Videos werden für die Übertragung nicht unterstützt:",
    "broadcast_noSupportedNDP500": "Die folgenden ausgewählten Videos werden auf NDP500/600 für die Übertragung nicht unterstützt:"
  },
  "resources": {
    "uploadNameLengthError": "Der Dateiname darf nicht mehr als 100 Wörter überschreiten!",
    "onUploadFile": "Keine Dateien zum Hochladen",
    "open": "Öffnen",
    "fold": "Falten",
    "close": "Schließen",
    "PublicCloud": "Öffentlicher Speicher",
    "IndividualCloud": "Persönlicher Speicher",
    "TransfersHistory": "Übertragungsverlauf",
    "btnDownload": "Herunterladen",
    "btnDelete": "Löschen",
    "btnUploadFile": "Datei hochladen",
    "btnNewFolder": "Neuer Ordner",
    "btnBake": "Zurück zur vorherigen",
    "coxAll": "Alles",
    "uploadError": "Die Dateigröße darf 1 GB nicht überschreiten!",
    "MD5": "MD5-Verifizierung",
    "merge": "Zusammenführen",
    "transcoding": "Transkodieren",
    "uploadFailed": "Hochladen fehlgeschlagen",
    "fileError": "Dateilesefehler, bitte überprüfen Sie die Datei.",
    "tableName": "Name",
    "tableSize": "Größe",
    "tableType": "Typ",
    "tableTimeAdded": "Hinzugefügte Zeit",
    "tableAction": "Aktion",
    "btnRename": "Umbenennen",
    "btnMoveTo": "Verschieben nach...",
    "ClearAll": "Alles löschen",
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "save": "Speichern",
    "addSuccess": "Erfolgreich hinzugefügt!",
    "addError": "Hinzufügen fehlgeschlagen!",
    "editSuccess": "Erfolgreich bearbeitet!",
    "editError": "Bearbeiten fehlgeschlagen!",
    "delSuccess": "Erfolgreich gelöscht!",
    "delError": "Löschen fehlgeschlagen!",
    "diskError3000": "Die Gesamtgröße des Speichers wurde überschritten, Operation fehlgeschlagen!",
    "diskError3001": "Die verwendete öffentliche Speichermenge wurde überschritten, Operation fehlgeschlagen!",
    "diskError3002": "Die verwendete individuelle Speichermenge wurde überschritten, Operation fehlgeschlagen!",
    "diskError3003": "Daten können nicht gefunden werden, bitte überprüfen Sie, ob der Medienserver gebunden ist!",
    "diskError3004": "Der Ordnername existiert bereits!",
    "diskError3005": "Fehler beim Abrufen des Ordners!",
    "diskError3006": "Auf derselben Ebene können nicht mehr als 99 Ordner erstellt werden!",
    "diskError3007": "Der gleiche Dateiname existiert und die Änderung ist fehlgeschlagen!",
    "diskError3008": "Der gleiche Ordnername existiert und die Änderung ist fehlgeschlagen!",
    "diskError3009": "Die Datei überschreitet den verbleibenden Speicherplatz und das Hochladen ist fehlgeschlagen!",
    "diskError3010": "Hochladen fehlgeschlagen!",
    "diskError3011": "Dateiüberprüfung fehlgeschlagen, bitte laden Sie die Datei erneut hoch!",
    "diskError3012": "Fehler beim Abrufen der privaten Cloud-Adresse, Operation fehlgeschlagen!",
    "diskError3013": "Mehrere Dateikombinationen dürfen 100 MB nicht überschreiten, große Dateien bitte separat herunterladen!",
    "diskError3014": "Komprimierung fehlgeschlagen, bitte wählen Sie die Datei erneut für den Download aus!",
    "diskError3015": "Sie benötigen Berechtigungen, um diese Aktion auszuführen",
    "downloadError": "Download fehlgeschlagen!",
    "mobileError": "Verschieben fehlgeschlagen!",
    "root": "Alle Dateien",
    "Name": "Name",
    "Size": "Größe",
    "Type": "Typ",
    "uploadFile": "Datei hochladen",
    "newFolder": "Neuer Ordner",
    "tableTime": "Zeit",
    "permission": "Unzureichende Berechtigungen!",
    "notifyTitle": "Benachrichtigung",
    "notifyContent": "Der Benutzer hat nicht genügend Berechtigungen, um darauf zuzugreifen!",
    "sortFileName": "Dateiname",
    "sortTime": "Zeit",
    "sortSize": "Größe",
    "sortType": "Typ",
    "moveTo": "Verschieben nach",
    "test": "Neu",
    "delTitle": "Löschen?",
    "delTitleContent": "Der ausgewählte Inhalt wird aus der Datenbank gelöscht. Die Operation kann nicht rückgängig gemacht werden. Möchten Sie fortfahren?",
    "delCancelButton": "Abbrechen",
    "delConfirmButton": "Bestätigen"
  },
  "userMge": {
    "userName": "Benutzername:",
    "jobNumber": "Mitarbeiter-ID:",
    "email": "E-Mail:",
    "phone": "Telefon:",
    "group": "Gruppe:",
    "oldPassword": "Altes Passwort:",
    "newPassword": "Neues Passwort:",
    "confirmNewPassword": "Neues Passwort bestätigen:",
    "btnSave": "Änderung speichern",
    "titleChangePassword": "Passwort ändern",
    "titleMyProfile": "Mein Profil",
    "name": "Spitzname:",
    "error1400": "Konto (benutzerdefiniert) existiert bereits, Operation fehlgeschlagen!",
    "error1401": "Konto (systemgeneriert) existiert bereits, Operation fehlgeschlagen!",
    "error1402": "Gruppe existiert nicht, Import fehlgeschlagen!",
    "error1403": "Datenfehler",
    "error1404": "Unzureichende Berechtigungen",
    "selUser": "Bitte wählen Sie einen Benutzer aus!",
    "error1405": "Fehler beim Abrufen der Rolle",
    "error1406": "Das Format der importierten Benutzerdaten ist falsch",
    "error1407": "E-Mail existiert bereits, Operation fehlgeschlagen.",
    "error1408": "Telefon existiert bereits, Operation fehlgeschlagen.",
    "editSuccess": "Erfolgreich gespeichert!",
    "ChangePassword": "Passwort ändern",
    "UserPrivacyAgreement": "Datenschutzbestimmungen des Benutzers"
  },
  "information": {
    "_2602": "Gerät offline",
    "_2603": "Übertragung fehlgeschlagen",
    "_2604": "Die Übertragung wurde unterbrochen",
    "_2605": "Der Speicherplatz ist voll",
    "_2606": "vor wenigen Minuten",
    "_2607": "vor wenigen Stunden",
    "_2609": "Fehler, bitte ",
    "_2609_a": "klicken Sie hier ",
    "_2609_time": "um es rechtzeitig zu behandeln",
    "userType": "Administrator",
    "unreadNoticeFirst": "Benachrichtigungen zuerst lesen",
    "sortByTime": "Nach Zeit sortieren",
    "coxRead_1": "Gelesen",
    "coxRead_0": "Ungelesen",
    "allCoxRead": "Alle als gelesen markieren",
    "load": "Wird geladen...",
    "noData": "Keine weiteren Daten",
    "viewALLMessages": "Alle Nachrichten anzeigen"
  },
  "input": {
    "select": "Bitte wählen",
    "thisField": "Dieses Feld muss ausgefüllt werden.",
    "titleShooleNub60": "weniger als 60 Zeichen",
    "titleShooleNub300": "weniger als 300 Zeichen",
    "Offline": "Offline"
  },
  "schedule": {
    "OnlyManual": "Nur manuell",
    "runStartNow": "Aufgabe ausführen",
    "runStopNow": "Aufgabe stoppen",
    "tackExecutionStart": "Aufgabe läuft",
    "tackExecutionStop": "Aufgabenausführung gestoppt",
    "dehumidification": "Entfeuchtung",
    "airSupply": "Luftversorgung",
    "masterControl": "Haupt:",
    "powerSupply": "Strom",
    "lockScreen": "Sperren",
    "RecordingControl": "Aufnahme Steuerung",
    "RecordingControlSystem": "Vortragsaufzeichnungssystem",
    "LiquidCrystal": "Interaktives LCD-Display",
    "projector": "Projektor",
    "othertype": "Sonstiges",
    "childLock": "Kindersicherung",
    "energySaving": "Energiesparmodus",
    "signalSourceSwitching": "Eingangsquelle",
    "other": "Weitere Funktionen:",
    "otherFunction": "Funktion",
    "send": "Senden",
    "ON": "AN",
    "OFF": "AUS",
    "btnAddSchedule": "Wiederherstellen",
    "EditSchedulelist": "Planer bearbeiten",
    "AddSchedulelist": "Planer hinzufügen",
    "RestoreSchedulelist": "Wiederherstellen",
    "btn": "Abbrechen",
    "btnNewList": "Neuer Planer",
    "ListName": "Name",
    "Cannotquit": "Pflicht",
    "NOCannotquit": "NEIN",
    "ListValidityPeriod": "Gültigkeitszeitraum",
    "ListDescription": "Beschreibung",
    "currentSchedule": "Planerliste",
    "historySchedule": "Historienliste",
    "selectTime": "Zeit",
    "selectTimeTable": "Zeit",
    "taskType": "Aufgabentyp",
    "selectBroadcasting": "Übertragung",
    "selectDeviveControl": "Gerätesteuerung",
    "newSchedule": "Neue Aufgabe",
    "newChecklist": "Neue Checkliste",
    "titleStatus": "Status",
    "titleType": "Typ",
    "titleStartTime": "Startzeit",
    "titleEndTime": "Endzeit",
    "titleRepeat": "Wiederholen",
    "titleName": "Name",
    "titleAction": "Aktion",
    "tableEnabled": "Aktiviert",
    "tablePaused": "Pausiert",
    "tableEdit": "Bearbeiten",
    "tableDelete": "Löschen",
    "tableVolumeEdit": "Übertragungslautstärke",
    "tableBroadcastTitle": "Titel",
    "tableBroadcastContent": "Inhalt",
    "tableBroadcastList": "Liste",
    "tableBroadcast": "Pflicht",
    "btnRemoveCompletely": "Vollständig entfernen",
    "btnEnabled": "Aktivierte Aufgabe",
    "btnPaused": "Aufgabe deaktivieren",
    "btnDelete": "Löschen",
    "repeat0": "MO",
    "repeat1": "DI",
    "repeat2": "MI",
    "repeat3": "DO",
    "repeat4": "FR",
    "repeat5": "SA",
    "repeat6": "SO",
    "dialogTitleAdd": "Neue Gerätesteuerungsaufgabe",
    "dialogTitleEdit": "Gerätesteuerungsaufgabe bearbeiten",
    "newBroadcastingSchedule": "Neue Broadcast-Aufgabe",
    "editBroadcastingSchedule": "Broadcast-Aufgabe bearbeiten",
    "chooseDevice": "Gerät auswählen",
    "timeSetting": "Zeiteinstellung",
    "controlBroadcasting": "Broadcast-Option",
    "controlOption": "Kontrolloption",
    "scheduleName": "Aufgabenname:",
    "destination": "Ziel",
    "timeTilte": "Zeit",
    "repeatTitle": "Wiederholen",
    "dialogRepeat0": "MO",
    "dialogRepeat1": "DI",
    "dialogRepeat2": "MI",
    "dialogRepeat3": "DO",
    "dialogRepeat4": "FR",
    "dialogRepeat5": "SA",
    "dialogRepeat6": "SO",
    "dialogOnceType": "Einmal",
    "dialogRepeatType": "Wiederholen",
    "Manual": "Manuell",
    "ManualContent": "Sie können diese Aufgaben manuell ausführen, nachdem Sie die Konfiguration abgeschlossen haben.",
    "mainPower": "Hauptstrom",
    "powerControl": "Leistungssteuerung",
    "tableDisplayInputSwitch": "Anzeigeeingangsschalter",
    "tableAirConditioning": "Klimaanlage",
    "tableProjectionScreen": "Projektionsschirm",
    "tableElectronicLock": "Elektrisches Schloss",
    "interactiveFlatPanel": "Interaktive Flachbildschirm",
    "displayInputSwitch": "Anzeigeeingangsschalter",
    "speakerVolume": "Audio-Lautstärke",
    "MICVolume": "Mikrofon-Lautstärke",
    "ProjectionScreen": "Projektionsschirm",
    "ElectronicLock": "Elektrisches Schloss",
    "AirConditioning": "Klimaanlage",
    "AirConditioningPower": "Strom",
    "AirConditioningModel": "Modell",
    "AirConditioningTEMP": "Temperatur",
    "AirConditioningFanSpeed": "Lüftergeschwindigkeit",
    "OPEN": "ÖFFNEN",
    "CLOSE": "SCHLIESSEN",
    "UP": "HOCH",
    "DOWN": "RUNTER",
    "PowerOFF": "AUS",
    "PowerON": "AN",
    "ModelAuto": "Automatisch",
    "ModelCool": "Kühlen",
    "ModelHeat": "Wärmen",
    "ModelAir": "Luftseitig",
    "TEMPLow": "Niedrig",
    "TEMPMiddle": "Mittel",
    "TEMPHigh": "Hoch",
    "btnSave": "Speichern",
    "btnNext": "WEITER",
    "StartTime": "Startzeit",
    "StopTime": "Stoppzeit",
    "Mandatory": "Pflicht",
    "Video": "Video und Audio",
    "Notification": "Benachrichtigung",
    "btnFile": "Medien-Datei auswählen",
    "LastingTime": "Dauer",
    "textTitle": "Titel",
    "textContent": "Inhalt",
    "textTitleLetters": "Weniger als 60 Zeichen",
    "textContentLetters": "Weniger als 320 Zeichen",
    "CannotquitYES": "JA",
    "CannotquitNo": "Nein",
    "YES": "Sind Sie sicher, dass Sie diesen Zeitplan löschen möchten?",
    "No": "Der gelöschte Zeitplan wird in die Historienliste verschoben und kann wiederhergestellt werden.",
    "delTitleContent": "Zeitplan löschen?",
    "delTitleListContent": "Das Löschen des Zeitplans führt dazu, dass die damit verbundenen Aufgaben gelöscht werden. Bitte bestätigen Sie.",
    "deleListTitle": "Sind Sie sicher, dass Sie diesen Zeitplan löschen möchten?",
    "delTitleListContent1": "Löschen?",
    "deleListTitle1": "Bestätigen",
    "delTitle": "ALLE",
    "btnConfirm": "Übertragung",
    "coxAll": "Gerätesteuerung",
    "coxBroadcasting": "JA",
    "coxDeviveControl": "NEIN",
    "rdMandatory": "Startdatum",
    "noRdMandatory": "Enddatum",
    "startDate": "-",
    "endedDate": "Typ",
    "or": "Zeit wählen",
    "broadcastingType": "Datum wählen",
    "ChooseTime": "Neuer Zeitplan",
    "ChooseDate": "Zeitplan bearbeiten",
    "newScheduleList": "Name",
    "editScheduleList": "Gültigkeitszeitraum",
    "listName": "Beschreibung",
    "listValidityPeriod": "Abbrechen",
    "listDescription": "Bestätigen",
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "save": "Speichern",
    "addSuccess": "Erfolgreich hinzugefügt!",
    "addError": "Fehler beim Hinzufügen!",
    "editSuccess": "Erfolgreich bearbeitet!",
    "editError": "Fehler beim Bearbeiten!",
    "delSuccess": "Erfolgreich gelöscht!",
    "delError": "Fehler beim Löschen!",
    "restoreSuccess": "Zeitplanliste erfolgreich wiederhergestellt",
    "restoreError": "Wiederherstellung der Zeitplanliste fehlgeschlagen",
    "restoreTitleContent": "Diese Zeit steht im Konflikt mit der Zeit im Zeitplan, bitte wählen Sie erneut",
    "Enabled": "Aktiviert",
    "Paused": "Pausiert",
    "Title": "Titel:",
    "Content": "Inhalt:",
    "errorScheduleNameRequired": "Der Name der Aufgabe muss ausgefüllt werden",
    "errorDeviceRequired": "Bitte wählen Sie das Zielgerät aus",
    "deleTitle": "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?",
    "loopList": "Loop-Liste",
    "errorPleaseDateRange": "Bitte wählen Sie einen Datumsbereich aus",
    "addError_2009": "Doppelte Scheduler-Bezeichnung",
    "conflicts": "Die Task-Zeit steht im Konflikt mit der folgenden:",
    "Pleaseagain": "Bitte erneut eingeben",
    "errorScheduleName": "Task-Name",
    "errorListName": "Scheduler-Name",
    "today": "Heute",
    "yesterday": "Gestern",
    "thisWeek": "Diese Woche",
    "lastWeek": "Letzte Woche",
    "lastMonth": "Letzten Monat",
    "thisMonth": "Diesen Monat",
    "times": "Mal",
    "TimeConflicts": "Zeitkonflikte",
    "editError_2006": "Gerät nicht gefunden",
    "editError_2010": "Doppelte Aufgabenbezeichnung",
    "editError_2100": "Die Aufgabe ist abgelaufen, kann nicht gestartet werden.",
    "ListTimeExpired": "Scheduler-Zeit ist abgelaufen, bitte wählen Sie erneut",
    "TimeExpired": "Zeit abgelaufen",
    "ControlOption": "Kontrolloption fehlt",
    "Pleaseleastone": "Bitte wählen Sie mindestens eine Kontrolloption aus",
    "Enter": "Eintragen",
    "TitleFilled": "Titel muss ausgefüllt werden",
    "ContentFilled": "Inhalt muss ausgefüllt werden",
    "PleaseMediaFile": "Bitte wählen Sie eine Mediendatei aus",
    "PleaseSchedule": "Bitte wählen Sie eine Aufgabe aus",
    "delTitleScheduleContent": "Die gelöschte Aufgabe kann nicht wiederhergestellt werden.",
    "deleTitleSchedule": "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?",
    "deleteScheduleTitle": "Bitte wählen Sie die zu löschende Aufgabe aus",
    "PleaseFillColumn": "Bitte geben Sie den Scheduler-Namen ein",
    "PleaseDate": "Bitte wählen Sie das Datum aus",
    "Previous": "Vorherige",
    "RemoteControl": "Fernsteuerung",
    "taskhasexpired": "Diese Aufgabe ist abgelaufen, wenden Sie sich bitte an den Ersteller, um die Zeit zu aktualisieren.",
    "execute": "Ausführen",
    "broadcastingList": "Sende-Liste",
    "volumeSuccess": "Lautstärke erfolgreich eingestellt",
    "volumeFailed": "Lautstärkeregelung fehlgeschlagen"
  },
  "live": {
    "StreamingRoom": "Streaming-Raum",
    "btnAddNewRoom": "Neuen Raum hinzufügen",
    "Steaming": "Streaming",
    "Creater": "Host:",
    "Address": "RTMP-Adresse:",
    "StreamingURL": "URL des Live-Streamings:",
    "DestinationNMP": "Ziel-NMP auswählen:",
    "stop": "STOPP",
    "stat": "START",
    "btnCope": "Klicken, um ZU KOPIEREN",
    "QRcode": "QR-Code",
    "Refresh": "Aktualisieren",
    "AddNewRoomTitle": "Neuen Streaming-Raum hinzufügen",
    "editNewRoomTitle": "Streaming-Raum bearbeiten",
    "roomName": "Raumname:",
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "save": "Speichern",
    "delTitleContent": "Sind Sie sicher, dass Sie diesen Zeitplan löschen möchten?",
    "delTitle": "Löschen?",
    "delCancelButton": "Abbrechen",
    "delConfirmButton": "Bestätigen",
    "addSuccess": "Erfolgreich hinzugefügt!",
    "addError": "Hinzufügen fehlgeschlagen!",
    "editSuccess": "Erfolgreich bearbeitet!",
    "editError": "Bearbeiten fehlgeschlagen!",
    "delSuccess": "Erfolgreich gelöscht!",
    "delError": "Löschen fehlgeschlagen!",
    "Stopstreaming": "Streaming beenden",
    "Startstreaming": "Streaming starten",
    "error2504": "Konnte die Live-Streaming-Adresse des Medienservers nicht abrufen",
    "error2505": "Duplizierter Streaming-Raumname",
    "error2506": "Das Gerät ist bereits von einem anderen Streaming-Signal belegt",
    "error1900": "Der abgerufene Parameter ist leer",
    "error2503": "Konnte keine Medienserver-Informationen abrufen",
    "error2507": "Duplizierte Live-Streaming-Adresse",
    "copySuccess": "Der Inhalt wurde in die Zwischenablage kopiert.",
    "copyError": "Der Browser unterstützt das automatische Kopieren nicht",
    "flashControl": "Flash ist nicht installiert oder aktiviert. Bitte versuchen Sie es nach der Installation oder Aktivierung von Flash erneut.",
    "liveStreaming": "Keine Live-Streaming-Quelle gefunden.",
    "btnflash": "Installieren/Aktivieren",
    "serverAddress": "Serveradresse",
    "addressKey": "Schlüssel:",
    "watchingAddress": "Anzeigedaten",
    "audioOnly": "Nur Audio",
    "enterTheKey": "Der Schlüssel muss ausgefüllt werden."
  },
  "guidepages": {
    "next": "Nächstes Steuergerät",
    "next1": "Nächster Versuch zu steuern",
    "next2": "Nächste Übertragung",
    "next3": "Nächster Start der Übertragung",
    "next4": "Nächster Stop der Übertragung",
    "next5": "Nächste Textübertragung",
    "next6": "Nächste Aufgabenstellung",
    "next7": "Nächste neue Aufgabe hinzufügen",
    "next8": "Nächste Historienliste",
    "next9": "Nächster Cloud-Speicher",
    "next10": "Nächste Live-Streaming",
    "next11": "Nächste Live-Streaming einrichten",
    "exit": "Beenden",
    "guideContent": "Inhaltsanleitung",
    "btnHomepage": "Startseite",
    "btnDevices": "Geräte",
    "btnBroadcast": "Übertragung",
    "btnSchedule": "Zeitplan",
    "btnResources": "Ressourcen",
    "btnStreaming": "Streaming",
    "btnPrevious": "Vorherige"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
    }
}



// WEBPACK FOOTER //
// ./src/lang/de.js